import React from 'react';

export default class  Page8 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToBeAssertive');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>Further Information</div>
                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBeInnovative')}>How
                                                        to be innovative</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToThinkAboutProblemsLaterally')}>How
                                                        to think about problems laterally</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToRaiseEnergyLevels')}>How
                                                        to raise energy levels</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMotivateOthers')}>How
                                                        to motivate others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                        to influence others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToCommunicateYourVision')}>How
                                                        to communicate your vision.</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title referencepad"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES</div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Latané, B. &amp; Darley,
                                                    J. (1970).<span className="subtiltereg"> The unresponsive bystander: Why doesn’t he help?</span> New
                                                    Jersey: Prentice-Hall, Inc.</p></li>
                                                <li><p className="further_info_content">Davis,
                                                    M. &amp; Eshelman, E. (2008). <span className="subtiltereg">The Stress &amp; Relaxation Workbook.</span> New
                                                    Harbinger Publications, Oakland, CA.</p></li>
                                                <li><p className="further_info_content">Galassi,
                                                    M. &amp; Galassi J. (1977).<span className="subtiltereg"> Assert Yourself.</span> Human
                                                    Science Press.</p></li>
                                                <li><p className="further_info_content">Smith, M. J.
                                                    (1985). <span className="subtiltereg">When I say no, I feel guilty.</span> Bantam.
                                                </p></li>
                                            </ol>

                                            <div className="left-btn"><div  onClick={this.props.handleChangePage('Page7')}
                                                                         className="button-next-previous-done">&lt;&lt; Previous </div>
                                            </div>
                                            <div className="right-btn"><div
                                                onClick={this._savePageStatus('People')}
                                                className="button-next-previous-done">Done</div></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}